import { useState } from 'react'
import { Button, Group, Radio, Stack, Textarea } from '@mantine/core'

// #1131 応募者側の面談候補選択(柱4-3)。GET /applications/:id(expert 本人 / 面談が proposing のときだけ)に
// JobApplicationDetail(#1121)とは別の island としてマウントする(JobApplicationDetail.jsx 自体は変更しない)。
//
// 候補日時から 1 つを選ぶ、または「いずれの候補日時も不可」を選び、通常の form POST で送信する
// (fetch は使わない)。選択に応じて <form> の action を choose_slot / decline のどちらかに切り替える。
// CSRF トークンはレイアウトの csrf_meta_tags(<meta name="csrf-param"> / <meta name="csrf-token">)から読む。
//
// 「Bizlink への連絡事項」(applicant_note)は任意の自由文。Bizlink 担当者(admin)のみが確認し、
// 企業には一切送られない(非媒介原則。docs/application-tracking.md §5 柱4)。
const DECLINE_VALUE = 'declined'

function readCsrfMeta(name) {
  if (typeof document === 'undefined') return null
  const meta = document.querySelector(`meta[name="csrf-${name}"]`)
  return meta ? meta.content : null
}

export default function InterviewSlotPicker({ slots = [], chooseSlotAction, declineAction }) {
  const [choice, setChoice] = useState('')
  const csrfParam = readCsrfMeta('param')
  const csrfToken = readCsrfMeta('token')

  const action = choice === DECLINE_VALUE ? declineAction : chooseSlotAction

  return (
    <Stack component="form" method="post" action={action} gap="md">
      {csrfParam && csrfToken ? <input type="hidden" name={csrfParam} value={csrfToken} /> : null}

      <Radio.Group
        name="slot_id"
        label="面談候補日時を選択してください"
        value={choice}
        onChange={setChoice}
      >
        <Stack mt="xs" gap="xs">
          {slots.map((slot) => (
            <Radio key={slot.id} value={String(slot.id)} label={`${slot.startsAt} 〜 ${slot.endsAt}`} />
          ))}
          <Radio value={DECLINE_VALUE} label="いずれの日時も都合が合わない" />
        </Stack>
      </Radio.Group>

      <Textarea
        name="applicant_note"
        label="Bizlink への連絡事項"
        description="Bizlink 担当者のみが確認します。企業には送られません。"
        placeholder="任意"
        autosize
        minRows={2}
        maxRows={6}
      />

      <Group justify="flex-end">
        <Button type="submit" disabled={!choice}>
          {choice === DECLINE_VALUE ? 'いずれも不可で回答する' : 'この日時で確定する'}
        </Button>
      </Group>
    </Stack>
  )
}
